// tslint:disable:no-any
// tslint:disable:no-string-literal

import React, { Component } from 'react';
import { DIVE_TYPES } from '../constants/DiveEnums';
import DiveMap from '../components/DiveMap';
import {
    DEFAULT_MAP_CENTER,
    DEFAULT_MAP_ZOOM
} from '../constants/MapVariables';
import Textarea from 'react-textarea-autosize';
import { DisplayMixture } from '../components/Display';
import { SettingsService } from '../services/SettingsService';

export interface INewDiveFormProps {
    dive: any;
    onChangeDiveData: (e: any) => void;
    onChangeDiveType: (e: any) => void;
    onChangeMixesData: (e: any) => void;
    onChangeGpsData: (e: any) => void;
    submitDivesData: (e: any) => void;
    showConfirmSubmit: (e: any) => void;
    isFieldValid: any;
    validFields?: any;
    requiredFields?: any;
    disableSubmit: boolean;
    confirmSubmit: boolean;
    divesData: any;
    diveId: any;
}

interface INewDiveFormState {
    dive: any;
    diveId: any;
    divesData: any;
    disableSubmit: boolean;
    confirmSubmit: boolean;
    center: any;
    zoom: any;
    profileSettings: any;
}

class NewDiveForm extends Component<INewDiveFormProps, INewDiveFormState> {
    constructor(props: INewDiveFormProps) {
        super(props);
        this.state = {
            center: DEFAULT_MAP_CENTER,
            zoom: DEFAULT_MAP_ZOOM,
            diveId: props.diveId,
            dive: props.dive,
            divesData: props.divesData,
            disableSubmit: false,
            confirmSubmit: false,
            profileSettings: null
        };
    }

    componentDidMount() {
        const profileSettings = SettingsService.getInstance().getSettings();

        this.setState({
            profileSettings: (profileSettings ? profileSettings.config : null)
        });
    }

    componentWillReceiveProps(nextProps: INewDiveFormProps) {
        if (
            nextProps.dive !== this.state.dive ||
            nextProps.diveId !== this.state.diveId ||
            nextProps.divesData !== this.state.divesData ||
            nextProps.disableSubmit !== this.state.disableSubmit ||
            nextProps.confirmSubmit !== this.state.confirmSubmit
        ) {
            this.setState({
                diveId: nextProps.diveId,
                dive: nextProps.dive,
                divesData: nextProps.divesData,
                disableSubmit: nextProps.disableSubmit,
                confirmSubmit: nextProps.confirmSubmit
            });
        }
    }

    changeDiveData(e: any) {
        var newDive = this.state.dive;

        if (
            newDive.diveAndMixesConfirmation.dive[e.target.name] !==
            e.target.value
        ) {
            newDive.diveAndMixesConfirmation.dive[e.target.name] =
                e.target.value;

            this.props.onChangeDiveData(e);
        }
    }

    onChangeDiveType(e: any) {
        var newDiveType = this.state.dive.diveAndMixesConfirmation.dive
            .diveType;
        if (e.target.checked === true) {
            newDiveType.push(e.target.name);
        }
        if (e.target.checked === false) {
            newDiveType = newDiveType.filter((diveType: any) => {
                return diveType !== e.target.name;
            });
        }

        this.props.onChangeDiveType(newDiveType);
    }

    onChangeMixesData(mixesIndex: any, e: any) {
        var newMixData = this.state.dive.diveAndMixesConfirmation.mixes;
        newMixData[mixesIndex][e.target.name] = e.target.value;

        this.props.onChangeMixesData(newMixData);
    }

    onMapClick(e: any) {
        this.props.onChangeGpsData(e);
    }

    checkValid(name: any, value: any) {
        return this.props.isFieldValid(name, value);
    }

    getDiveData(name: any, defaultValue: any = '') {
        // jsou vybrany vsechny ponory
        if (this.state.diveId === null) {
            let value: any = undefined;
            let different = false;
            // projdu vsechny ponory, kontroluji rozdily
            this.state.divesData.forEach((dive: any) => {
                if (
                    dive.diveAndMixesConfirmation &&
                    dive.diveAndMixesConfirmation.dive
                ) {
                    if (value === undefined) {
                        value = dive.diveAndMixesConfirmation.dive[name];
                    } else if (
                        value !== dive.diveAndMixesConfirmation.dive[name]
                    ) {
                        different = true;
                    }
                }
            });
            // vystup
            if (different === false && value !== null) {
                return value;
            }
            // v datech jsou rozdily
            return defaultValue;
        }

        // je vybran pouze jeden ponor
        if (
            this.state.dive &&
            this.state.dive.diveAndMixesConfirmation &&
            this.state.dive.diveAndMixesConfirmation.dive &&
            this.state.dive.diveAndMixesConfirmation.dive[name]
        ) {
            return this.state.dive.diveAndMixesConfirmation.dive[name];
        }

        // defaultni vystup
        return defaultValue;
    }

    getDiveType(type: any, defaultValue: boolean = false) {
        // jsou vybrany vsechny ponory
        if (this.state.diveId === null) {
            let value: any = undefined;
            let different = false;
            // projdu vsechny ponory, kontroluji rozdily
            this.state.divesData.forEach((dive: any) => {
                if (
                    dive.diveAndMixesConfirmation &&
                    dive.diveAndMixesConfirmation.dive
                ) {
                    if (value === undefined) {
                        value =
                            dive.diveAndMixesConfirmation.dive.diveType.indexOf(
                                type
                            ) !== -1;
                    } else if (
                        value !==
                        (dive.diveAndMixesConfirmation.dive.diveType.indexOf(
                            type
                        ) !==
                            -1)
                    ) {
                        different = true;
                    }
                }
            });
            // vystup
            if (different === false && value !== null) {
                return value;
            }
            // v datech jsou rozdily
            return defaultValue;
        }

        // je vybran pouze jeden ponor
        if (
            this.state.dive &&
            this.state.dive.diveAndMixesConfirmation &&
            this.state.dive.diveAndMixesConfirmation.dive &&
            this.state.dive.diveAndMixesConfirmation.dive.diveType
        ) {
            return (
                this.state.dive.diveAndMixesConfirmation.dive.diveType.indexOf(
                    type
                ) !== -1
            );
        }

        // defaultni vystup
        return defaultValue;
    }

    render() {
        if (!this.state.profileSettings) {
            return (<div />);
        }

        return (
            <div>
                <div className="standardContainer__body asDivider">
                    <div className="newDiveForm">
                        {this.state.diveId === null && (
                            <span className="infoMessage">
                                General information is the same for all dives.
                            </span>
                        )}

                        <div className="form marginBottom">
                            <div>
                                <p className="inputLabel">Locality</p>
                                <input
                                    type="text"
                                    name="location"
                                    value={this.getDiveData('location')}
                                    onChange={e => this.changeDiveData(e)}
                                />
                            </div>

                            <div>
                                <p className="inputLabel">Site</p>
                                <input
                                    type="text"
                                    name="site"
                                    value={this.getDiveData('site')}
                                    onChange={e => this.changeDiveData(e)}
                                />
                            </div>

                            <div
                                className={
                                    this.state.dive.validFields[
                                        'visibility'
                                    ] === false
                                        ? ' error'
                                        : ''
                                }
                            >
                                <p className="inputLabel">Visibility</p>
                                <div className={`units distance ` + this.state.profileSettings.unitOfLength}>
                                    <input
                                        type="text"
                                        name="visibility"
                                        value={this.getDiveData('visibility')}
                                        onChange={e => this.changeDiveData(e)}
                                    />
                                    {this.state.dive.validFields[
                                        'visibility'
                                    ] === false && (
                                        <div className="alert">
                                            Please enter the real value
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div
                                className={
                                    this.state.dive.validFields[
                                        'surfaceTemp'
                                    ] === false
                                        ? ' error'
                                        : ''
                                }
                            >
                                <p className="inputLabel">
                                    Surface temperature
                                </p>
                                <div className={`units temperature ` + this.state.profileSettings.unitOfTemperature}>
                                    <input
                                        type="text"
                                        name="surfaceTemp"
                                        value={this.getDiveData('surfaceTemp')}
                                        onChange={e => this.changeDiveData(e)}
                                    />
                                    {this.state.dive.validFields[
                                        'surfaceTemp'
                                    ] === false && (
                                        <div className="alert">
                                            Please enter the real value
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div className="">
                                <p className="inputLabel">Salinity</p>
                                <select
                                    name="salinity"
                                    value={this.getDiveData(
                                        'salinity',
                                        'unknown'
                                    )}
                                    onChange={e => this.changeDiveData(e)}
                                >
                                    <option value="unknown">Unknown</option>
                                    <option value="seaWater">Sea water</option>
                                    <option value="freshWater">
                                        Fresh water
                                    </option>
                                    <option value="mixed">Mixed</option>
                                </select>
                            </div>

                            <div className="">
                                <p className="inputLabel">Weather</p>
                                <select
                                    name="weather"
                                    value={this.getDiveData(
                                        'weather',
                                        'unknown'
                                    )}
                                    onChange={e => this.changeDiveData(e)}
                                >
                                    <option value="unknown">Unknown</option>
                                    <option value="clear">Clear</option>
                                    <option value="partyCloudy">
                                        Party cloudy
                                    </option>
                                    <option value="cloudy">Cloudy</option>
                                    <option value="windy">Windy</option>
                                    <option value="rain">Rain</option>
                                    <option value="snow">Snow</option>
                                    <option value="storm">Storm</option>
                                </select>
                            </div>

                            <div
                                className={
                                    this.state.dive.validFields['weight'] ===
                                    false
                                        ? 'error'
                                        : ''
                                }
                            >
                                <p className="inputLabel">Weight</p>
                                <div className={`units weight ` + this.state.profileSettings.unitOfMass}>
                                    <input
                                        type="text"
                                        name="weight"
                                        value={this.getDiveData('weight')}
                                        onChange={e => this.changeDiveData(e)}
                                    />
                                    {this.state.dive.validFields['weight'] ===
                                        false && (
                                        <div className="alert">
                                            Please enter the real value
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div>
                                <p className="inputLabel">Partner</p>
                                <input
                                    type="text"
                                    name="partner"
                                    value={this.getDiveData('partner')}
                                    onChange={e => this.changeDiveData(e)}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="standardContainer__body asDivider">
                    <div className="newDiveForm">
                        <span className="smallTitle">GPS coordinates</span>

                        <div className="form">
                            <div
                                className={
                                    this.state.dive.validFields['latitude'] ===
                                    false
                                        ? 'error'
                                        : this.state.dive.requiredFields[
                                              'latitude'
                                          ] === true &&
                                          this.state.diveId !== null
                                          ? 'required'
                                          : ''
                                }
                            >
                                <p className="inputLabel">N</p>
                                <div className="units">
                                    <input
                                        type="text"
                                        name="latitude"
                                        value={this.getDiveData('latitude')}
                                        onChange={e => this.changeDiveData(e)}
                                    />
                                    {this.state.dive.validFields['latitude'] ===
                                        false && (
                                        <div className="alert">
                                            Please enter the real value
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div
                                className={
                                    this.state.dive.validFields.longitude ===
                                    false
                                        ? 'error'
                                        : this.state.dive.requiredFields
                                              .longitude === true &&
                                          this.state.diveId !== null
                                          ? 'required'
                                          : ''
                                }
                            >
                                <p className="inputLabel">E</p>
                                <div className="units">
                                    <input
                                        type="text"
                                        name="longitude"
                                        value={this.getDiveData('longitude')}
                                        onChange={e => this.changeDiveData(e)}
                                    />
                                    {this.state.dive.validFields.longitude ===
                                        false && (
                                        <div className="alert">
                                            Please enter the real value
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>

                        <DiveMap
                            diveData={
                                this.state.dive.diveAndMixesConfirmation.dive
                            }
                            point={{
                                lat:
                                    this.state.dive.validFields.latitude !==
                                        false &&
                                    this.getDiveData('latitude', null) !== null
                                        ? parseFloat(
                                              this.getDiveData('latitude')
                                          )
                                        : null,
                                lng:
                                    this.state.dive.validFields.longitude !==
                                        false &&
                                    this.getDiveData('longitude', null) !== null
                                        ? parseFloat(
                                              this.getDiveData('longitude')
                                          )
                                        : null
                            }}
                            center={this.state.center}
                            onMapClick={e => this.onMapClick(e)}
                            shared={false}
                        />
                    </div>
                </div>

                <div className="standardContainer__body asDivider">
                    <div className="newDiveForm">
                        <span className="smallTitle">Dive type</span>

                        <div className="form cf withCheckboxes">
                            {Object.keys(DIVE_TYPES).map(key => {
                                return (
                                    <div className="cf" key={key}>
                                        <label>
                                            <p className="inputLabel">
                                                {DIVE_TYPES[key]}
                                            </p>
                                            <input
                                                type="checkbox"
                                                name={key}
                                                checked={this.getDiveType(key)}
                                                onChange={e =>
                                                    this.onChangeDiveType(e)
                                                }
                                            />
                                        </label>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>

                <div className="standardContainer__body asDivider">
                    <div className="newDiveForm">
                        <span className="smallTitle">Description</span>

                        <div className="form cf">
                            <Textarea
                                name="description"
                                value={this.getDiveData('description', '')}
                                onChange={e => this.changeDiveData(e)}
                            />
                        </div>
                    </div>
                </div>

                {this.state.diveId != null &&
                    this.state.dive.diveAndMixes.mixes.length > 0 && (
                        <div className="standardContainer__body asDivider fullWidth noPaddingBottom">
                            <div className="newDiveForm">
                                <div className="form">
                                    <div className="diveDataTable">
                                        <div className="diveDataTable--row">
                                            <div className="diveDataTable--cell">
                                                Mixture
                                            </div>
                                            <div className="diveDataTable--cell">
                                                Tank volume
                                            </div>
                                            <div className="diveDataTable--cell">
                                                Start pressure
                                            </div>
                                            <div className="diveDataTable--cell">
                                                End pressure
                                            </div>
                                        </div>

                                        {this.state.dive.diveAndMixes.mixes.map(
                                            (key: any, index: any) => {
                                                var mixToConfirm = this.state
                                                    .dive
                                                    .diveAndMixesConfirmation
                                                    .mixes[index];
                                                var endV = this.state.dive
                                                    .validFields[
                                                    'endPressure' + index
                                                ];
                                                var endM = this.state.dive
                                                    .validFields[
                                                    'endPressure' +
                                                        index +
                                                        'message'
                                                ];
                                                return (
                                                    <div
                                                        key={index}
                                                        className="diveDataTable--row"
                                                    >
                                                        <div className="diveDataTable--cell">
                                                            <DisplayMixture
                                                                data={key}
                                                            />
                                                        </div>
                                                        <div
                                                            className={
                                                                'diveDataTable--cell mixesValueCodeL ' +
                                                                this.state.profileSettings.unitOfVolume +
                                                                (this.state.dive
                                                                    .validFields[
                                                                    'tankVolume' +
                                                                        index
                                                                ] === false
                                                                    ? ' error'
                                                                    : '')
                                                            }
                                                        >
                                                            <input
                                                                type="text"
                                                                name="tankVolume"
                                                                key={index}
                                                                value={
                                                                    mixToConfirm.tankVolume !==
                                                                    null
                                                                        ? mixToConfirm.tankVolume
                                                                        : ''
                                                                }
                                                                onChange={e =>
                                                                    this.onChangeMixesData(
                                                                        index,
                                                                        e
                                                                    )
                                                                }
                                                            />
                                                            {this.state.dive
                                                                .validFields[
                                                                'tankVolume' +
                                                                    index
                                                            ] === false && (
                                                                <div className="alert">
                                                                    Please enter
                                                                    the real
                                                                    value
                                                                </div>
                                                            )}
                                                        </div>
                                                        <div
                                                            className={
                                                                'diveDataTable--cell mixesValueCodeBar ' +
                                                                this.state.profileSettings.unitOfPressure +
                                                                (this.state.dive
                                                                    .validFields[
                                                                    'startPressure' +
                                                                        index
                                                                ] === false
                                                                    ? ' error'
                                                                    : '')
                                                            }
                                                        >
                                                            <input
                                                                type="text"
                                                                name="startPressure"
                                                                key={index}
                                                                value={
                                                                    mixToConfirm.startPressure !==
                                                                    null
                                                                        ? mixToConfirm.startPressure
                                                                        : ''
                                                                }
                                                                onChange={e =>
                                                                    this.onChangeMixesData(
                                                                        index,
                                                                        e
                                                                    )
                                                                }
                                                            />
                                                            {this.state.dive
                                                                .validFields[
                                                                'startPressure' +
                                                                    index
                                                            ] === false && (
                                                                <div className="alert">
                                                                    Please enter
                                                                    the real
                                                                    value
                                                                </div>
                                                            )}
                                                        </div>
                                                        <div
                                                            className={
                                                                'diveDataTable--cell mixesValueCodeBar ' +
                                                                this.state.profileSettings.unitOfPressure +
                                                                ((endV !==
                                                                    undefined &&
                                                                    endV ===
                                                                        false) ||
                                                                (endM !==
                                                                    undefined &&
                                                                    endM !==
                                                                        null)
                                                                    ? ' error'
                                                                    : '')
                                                            }
                                                        >
                                                            <input
                                                                type="text"
                                                                name="endPressure"
                                                                key={index}
                                                                value={
                                                                    mixToConfirm.endPressure !==
                                                                    null
                                                                        ? mixToConfirm.endPressure
                                                                        : ''
                                                                }
                                                                onChange={e =>
                                                                    this.onChangeMixesData(
                                                                        index,
                                                                        e
                                                                    )
                                                                }
                                                            />
                                                            {endV === false && (
                                                                <div className="alert">
                                                                    Please enter
                                                                    the real
                                                                    value
                                                                </div>
                                                            )}
                                                            {endM !== null && (
                                                                <div className="alert">
                                                                    {endM}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                );
                                            }
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                <div className="standardContainer__body">
                    <div className="newDiveForm center">
                        {this.state.disableSubmit === true && (
                            <button
                                className="btn btn--smallpill btn--backroundRed"
                                disabled
                            >
                                Save
                            </button>
                        )}

                        {this.state.disableSubmit !== true &&
                            this.state.confirmSubmit !== true && (
                                <button
                                    className="btn btn--smallpill btn--backroundRed"
                                    onClick={e => this.props.submitDivesData(e)}
                                >
                                    Save
                                </button>
                            )}

                        {this.state.disableSubmit !== true &&
                            this.state.confirmSubmit === true && (
                                <button
                                    className="btn btn--smallpill btn--backroundRed"
                                    onClick={e =>
                                        this.props.showConfirmSubmit(e)
                                    }
                                >
                                    Save
                                </button>
                            )}
                    </div>
                </div>
            </div>
        );
    }
}

export default NewDiveForm;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/NewDiveForm.tsx